import { render } from "./assessment-page.vue?vue&type=template&id=01f1b00a"
import script from "./assessment-page.vue?vue&type=script&lang=js"
export * from "./assessment-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__